import { useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { isMobileApp } from '@/lib/mobileAppPlatform';
import { requiresCorporateWeb } from '@/lib/corporate-web-policy.mjs';
import CorporateWebOnly from '@/pages/CorporateWebOnly';

export default function CorporateWebBoundary({ children }) {
  const { user, loading } = useAuth();
  const { pathname, search } = useLocation();
  if (requiresCorporateWeb({ native: isMobileApp(), user, path: pathname, search })) {
    return <CorporateWebOnly />;
  }
  // A restored session must resolve before any shared corporate page mounts.
  if (isMobileApp() && loading) return <p role="status" className="p-6">Cargando C&A…</p>;
  return children;
}
